import { StoricoModuloService } from './../services/storicomodulo.service';
import { RequestBuilder } from './../classes/request-builder';
import { IStoricoRisposte } from './../interfaces/IStoricoRisposte';
import { IAllegati } from './../interfaces/IAllegati';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, SelectItem, MenuItem } from 'primeng/api';
import { AlertUtil } from '../utils/alert-util';
import { IDocumento } from '../interfaces/IDocumento';
import { IMatriceDomande } from '../interfaces/IMatriceDomande';
import * as Enum from '../utils/enums';
import * as Constants from '../utils/constants';
import * as Moment from 'moment';
import { DocumentiService } from '../services/documenti.service';
import { Loading } from '../utils/loading';
import { finalize } from 'rxjs/operators';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IRichiesta } from '../interfaces/IRichiesta';
import { Util } from '../utils/util';
import { TranslateService } from '@ngx-translate/core';
import { IVersione } from '../interfaces/IVersione';
import { RichiestaService } from '../services/richiesta.service';
import { IEsecutore } from '../interfaces/IEsecutore';
import { IAggiudicatario } from '../interfaces/IAggiudicatario';

@Component({
  selector: 'app-documento-modal',
  templateUrl: './documento-modal.component.html',
  styleUrls: ['./documento-modal.component.css']
})
export class DocumentoModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel

  document: IDocumento
  richiestaSelected: IRichiesta
  indexQuestion: number = 1 //index for doc type allegato
  questions: IMatriceDomande[]
  allegati: IAllegati[]
  storicoRisposte: IStoricoRisposte[] = []
  types: SelectItem[];
  selectedType: string;
  TYPE = Enum.INPUT_TYPE_ENUM
  SRE = Enum.REQUEST_STATE_NAME_ENUM
  dataChange: boolean = false

  uploadedFiles: any[] = []; //for upload file

  it: any // Lingua del calendario

  isAffidatario: boolean //determines whether the user logged is affidatario 
  isAdmin: boolean //determines whether the user logged is admin 
  isAggiudicatario: boolean //determines whether the user logged is aggiudicatario 
  isPrefettura: boolean //determines whether the user logged is aggiudicatario 

  attachmentUrl: string = ""                  // url dell'allegato
  itemsAllegato: MenuItem[];
  fromFullTextSearch: boolean = false         //for workflow fulltextsearch
  fromVersioning: boolean = false             // fro workflow versioning
  userGuid: string                            //user guid
  lockField: boolean = true                   //for lock/unlock field
  lockUpload: boolean = true                   //for lock/unlock upload
  versionList: IVersione[] = []              //versionList of document 
  selectedVersion: IVersione                // version selected
  isDisabledUnlockButton: boolean = false   // for disabled unlock button
  maxVersion: number                       //index max of version
  fromScadenzario: boolean = false         //fromScadenzario
  fromEsecutore: boolean = false          // from Esecutore

  statiAntimafia: any[]
  esecutoreStatoAntimafia: string
  allegatoAntimafiaId: number //for upload statoAntimafia file
  fileAntimafiaName: string

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private alertUtil: AlertUtil,
    private documentiService: DocumentiService,
    private translate: TranslateService,
    private storicoModuloService: StoricoModuloService,
    private richiestaService: RichiestaService) {

    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.userGuid = localStorage.getItem(Constants.LS_USER_GUID)
    this.checkUserRole(userRole)

    this.richiestaSelected = this.config.data.richiesta
    this.fromFullTextSearch = this.config.data.fromFullTextSearch
    this.fromVersioning = this.config.data.fromVersioning
    this.fromScadenzario = this.config.data.fromScadenzario

    this.document = this.config.data.documento
    this.fromEsecutore = this.config.data.fromEsecutore
    let fromAlert: boolean = this.config.data.fromAlert // used from alerts page to check change versions
    if (this.document.Versioni && !this.fromVersioning) {
      this.document.Versioni.forEach(doc => {
        //push in array only confirmed doc
        if (doc.Confermato) {
          this.versionList.push(doc)
        }
      })
      this.maxVersion = this.getMaxOfArray()
      // preselect version from alert if modal is open from alert page, preselect max version otherwise
      if (fromAlert) {
        this.selectedVersion = this.versionList.find(version => version.Versione == this.document.Versione)
      }
      else {
        this.selectedVersion = this.versionList.find(version => version.Versione == this.maxVersion)
      }
    }


    this.types = [
      { label: '', value: true, icon: 'pi pi-check', styleClass: "valido" },
      { label: '', value: false, icon: 'pi pi-times', styleClass: "non-valido" }
    ];


    this.isDisabledUnlockButton = true
    if (this.document.Richiesta) {
      this.isDisabledUnlockButton = this.document.Richiesta.GUID_utente != this.userGuid
    }

    this.statiAntimafia = Constants.STATI_ANTIMAFIA
    this.esecutoreStatoAntimafia = this.statiAntimafia[1].value
  }

  /**
   * check role of user logged
   */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO
      || userRole == Enum.USER_TYPE_ENUM.GVS
      || userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isAffidatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO || userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isAggiudicatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.PREFETTURA) {
      this.isPrefettura = true
    }
  }

  ngOnInit() {
    this.setLanguageForCalendar()
    this.questions = this.document.MatriceModulo.MatriceDomande
    if (this.document.Data_scadenza) {
      this.document.Data_Scadenza = new Date(this.document.Data_scadenza)
    }
    this.allegati = this.document.Allegati
    this.questions.sort(this.sortQuestionsArray()) //sort array by ordine 
    this.questions.forEach(question => {
      if (question.Tipo == this.TYPE.UPLOAD) { //set Numero allegato custom for question type Upload
        this.setAllegatoObjForUploadQuestion(question)
      } else if (question.Tipo == this.TYPE.DATE) {
        if (question.RispostaCustom.Valore != null) {
          question.RispostaCustom.ValoreDate = new Date(question.RispostaCustom.Valore)
        }
      } else if (question.Tipo == this.TYPE.CHECKBOX) {
        this.checkBoxBooleanFromString(question)
      } else if (question.Tipo == this.TYPE.RADIOBUTTON) {
        this.setRadioButtonVal(question)
      }
      //AGGIUNTO CONTROLLO SUL TIPO labelEsecutore
      else if (question.Tipo == this.TYPE.LABEL_ESECUTORE) {
        question.Esecutore = this.getEsecutoreObjForLabelEsecutoreQuestion(question)
      } else if (question.Tipo == this.TYPE.TEXT && question.StatoAntimafia && question.Placeholder == "txtEsitoVerifica") {
        this.esecutoreStatoAntimafia = question.RispostaCustom.Valore ? question.RispostaCustom.Valore : this.esecutoreStatoAntimafia
      }
      question.RispostaCustom.Placeholder = question.Placeholder //set placeholder of response with placeholder of question
      this.checkForLockedUniqueField(question)
      //if from scadenzario and question type is Upload check expiration date
      if (this.fromScadenzario && question.Tipo == this.TYPE.UPLOAD) {
        this.checkExpirationDate(question)
      }
      this.storicoRisposte.push(question.RispostaCustom)
    })
  }

  /**
   * check for locked unique field
   * for Matrice modulo with id = 39,38,37,4
   * @param question matrice domande
   */
  private checkForLockedUniqueField(question: IMatriceDomande) {
    // check locking if question type is TEXT and question answer value is not empty
    if (question.Tipo == this.TYPE.TEXT && question.RispostaCustom && question.RispostaCustom.Valore && question.RispostaCustom.Valore != '') {
      switch (this.document.MatriceModulo.Id) {
        case 39://PERSONE
          if (question.RispostaCustom.Placeholder == "txtCFLavoratore") {
            this.setLockedField(question);
          }
          break
        case 38://MEZZI
        case 37:
          if (question.RispostaCustom.Placeholder.indexOf("txtTargaMatricola") > -1 || question.RispostaCustom.Placeholder.indexOf("txtTipologiaVeicolo") > -1) {
            this.setLockedField(question);
          }
          break
        case 4: //ESECUTORE
          if (question.RispostaCustom.Placeholder == ("txtPIVAImpresa")
            || question.RispostaCustom.Placeholder == ("txtNomeUtente")) {
            this.setLockedField(question);
          }
          break
      }
    }
    // else if (question.Tipo == this.TYPE.UPLOAD && this.richiestaSelected.TipoContratto.Nome == Constants.TIPO_CONTRATTO) {
    //   this.setLockedField(question)
    // }
  }

  /**
   * set locked at risposta custom
   * @param question question
   */
  private setLockedField(question: IMatriceDomande) {
    if (question.RispostaCustom.Valore != null) {
      question.RispostaCustom["locked"] = true;
    }
  }

  /**
   * for field allegati
   * @param menu 
   * @param event 
   * @param question 
   */
  openMenu(menu, event: any, question: IMatriceDomande) {
    this.optionsAllegato(event, question)
    menu.toggle(event)
  }

  /**
   * set options allegato
   * @param event 
   * @param question 
   */
  private optionsAllegato(event: any, question: IMatriceDomande) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(event, question);
          }
        }
      ];
      //if (this.document.Richiesta) {
      if (!(question.StatoAntimafia && !this.lockUpload || (this.isDisabledInput(question) && this.lockUpload) || this.isPrefettura)) {
        this.itemsAllegato.push({
          label: res["LBL_ALLEGATO_CANCELLA"], icon: 'pi pi-trash', command: () => {
            this.deleteAllegato(event, question);
          }
        })
      }
      // }
    })
  }


  /**
   * 
   * @param event event
   * @param question item 
   */
  dropDownCLick(event: any, question: IMatriceDomande) {
    this.optionsAllegato(event, question)
  }

  /**
   * sort questions array by ordine of matrice domande
   */
  private sortQuestionsArray(): (a: IMatriceDomande, b: IMatriceDomande) => number {
    return (a: IMatriceDomande, b: IMatriceDomande) => (a.Ordine > b.Ordine) ? 1 : ((b.Ordine > a.Ordine) ? -1 : 0);
  }

  /**
   * set allegato obj for single question
   * @param question question Item
   */
  setAllegatoObjForUploadQuestion(question: IMatriceDomande) {
    let allegatoObj: IAllegati = {
      Numero_allegato: this.indexQuestion.toString()
    }
    question.Allegato = allegatoObj
    this.indexQuestion++
    if (this.allegati) {
      this.allegati.forEach(allegato => {
        if (question.Allegato.Numero_allegato == allegato.Numero_allegato) {
          question.Allegato.Nome = allegato.Nome
          question.Allegato.Id = allegato.Id
          question.Allegato.Estensione = allegato.Estensione
          question.Allegato.DataScadenza = allegato.Scadenza ? new Date(allegato.Scadenza) : null
        }
      })
    }
  }

  /**
   * read string value from type checkbox and set boolean value ValoreCheck
   * @param question question
   */
  checkBoxBooleanFromString(question: IMatriceDomande) {
    if (question.RispostaCustom.Valore == "True") {
      question.RispostaCustom.ValoreCheck = true
    } else {
      question.RispostaCustom.ValoreCheck = false
    }

  }

  /**
   * read string value from type radioButton and set string value ValoreRadio
   * @param question question
   */
  setRadioButtonVal(question: IMatriceDomande) {
    if (question.RispostaCustom.Valore != null) {
      question.RispostaCustom.ValoreRadio = question.RispostaCustom.Valore
    } else {
      question.RispostaCustom.ValoreRadio = null
    }

  }

  /**
   * language for calendar
   */
  setLanguageForCalendar() {
    /**
    * Lingua italiana nel calendario
    */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };
  }

  /**
   * click save
   */
  onSubmit() {
    //Obj for service 
    if (this.document.Data_Scadenza) {
      this.document.Data_scadenza = this.formatDateForSave(this.document.Data_Scadenza)
    }
    this.questions = this.document.MatriceModulo.MatriceDomande
    this.storicoRisposte = [] //clean array  
    this.questions.forEach(question => {
      if (question.Tipo == this.TYPE.CHECKBOX) {
        this.changeBooleanToStringForSave(question)
      } else if (question.Tipo == this.TYPE.RADIOBUTTON) {
        this.getRadioButtonVal(question)
      } else if (question.Tipo == this.TYPE.DATE) { //format date for save
        if (question.RispostaCustom.ValoreDate) {
          question.RispostaCustom.Valore = this.formatDateForSave(question.RispostaCustom.ValoreDate)
        } else {
          question.RispostaCustom.Valore = null
        }
      } else if (question.Tipo == this.TYPE.UPLOAD) { //set name file to risposta custom valore
        question.RispostaCustom.Valore = question.Allegato ? question.Allegato.Nome : null
      } else if (question.Tipo == this.TYPE.TEXT && question.StatoAntimafia && question.Placeholder == "txtEsitoVerifica") {
        question.RispostaCustom.Valore = this.esecutoreStatoAntimafia
      }
      //SET VERSIONE TO RISPOSTACUSTOM ONLY HOME documento save
      if (!this.fromFullTextSearch && !this.fromScadenzario && !this.fromVersioning) {
        question.RispostaCustom.Versione = 1
      }
      this.storicoRisposte.push(question.RispostaCustom)
    })
    this.document.StoricoRisposte = this.storicoRisposte // set documento with new response

    if (this.areAllMandatoriesFilled()) {
      this.callSaveQuestionsOfDocumento()
    }
    else {
      this.alertUtil.showErrorAlert("LBL_ALL_FIELDS_MANDATORY", "", "", "")
    }
  }

  /**
   * change boolean value to string
   * @param question item
   */
  changeBooleanToStringForSave(question: IMatriceDomande) {
    if (question.RispostaCustom.ValoreCheck) { //get boolean value and set string value for save
      question.RispostaCustom.Valore = "True"
    } else {
      question.RispostaCustom.Valore = "False"
    }
  }

  /**
   * change boolean value to string
   * @param question item
   */
  getRadioButtonVal(question: IMatriceDomande) {
    if (question.RispostaCustom.ValoreRadio) {
      question.RispostaCustom.Valore = question.RispostaCustom.ValoreRadio
    } else {
      question.RispostaCustom.Valore = null
    }
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue item value
   */
  formatDateForSave(dateValue: Date): string {
    return Moment(dateValue).format("YYYY-MM-DDTHH:mm:ss")
  }

  /**
   * save questions of documento
   * @param documentoObj documentoObj
   */
  callSaveQuestionsOfDocumento() {
    //saveDocument
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.document)
    this.documentiService.saveStoricoModulo(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          if (this.allegatoAntimafiaId) {
            this.onSaveCertificatoAntimafia()
          } else {
            this.alertUtil.showAlert("LBL_MODULO_SAVE_SUCCESS", null, null, null, () => {
              this.ref.close(this.document)
            })
          }
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          // add params to message if error code is 313 or 314
          if (response.error.Code == 313 || response.error.Code == 314) {
            let params = { azienda: response.error.Param }
            this.alertUtil.showErrorAlert(errorKey, params)
          }
          else {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
          }
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }

      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey, null, null, null, () => {
          this.ref.close(error)
        })
      }
    )
  }


  /**
    * chiamata per salvataggio allegato STATO ANTIMAFIA all'azienda e alla tabella apposita
    * Per far visualizzare l'allegato e lo stato sulla filiera
    */
  onSaveCertificatoAntimafia() {
    Loading.isLoading = true
    //let fileToUplaod = this.uploadedAntimafiaFile ? this.uploadedAntimafiaFile : new ArrayBuffer(0)
    let azienda: any //azienda per antimafia (esecutore/aggiudicatario)
    let esecutore: IEsecutore = JSON.parse(localStorage.getItem(Constants.LS_ESECUTORE)) //get esecutore da LS
    let aggiudicatario: IAggiudicatario
    // se non ho esecutore e agisco come affidatario prendo i dati dall'aggiudicatario
    if (!esecutore && this.isAffidatario) {
      aggiudicatario = JSON.parse(localStorage.getItem(Constants.LS_AGGIUDICATARIO))
    }
    //valorizzo oggetto azienda e recupero l'id e lo stato antimafia 
    azienda = esecutore != null ? esecutore : aggiudicatario != null ? aggiudicatario : null
    let aziendaId = azienda ? String(azienda.Id) : ''
    let payload = new RequestBuilder({})
    this.documentiService.saveCertificatoAntimafia(payload, aziendaId, this.fileAntimafiaName, azienda.Stato_antimafia, this.allegatoAntimafiaId).pipe(
      finalize(() => {
        Loading.isLoading = false
      })
    ).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_MODULO_SAVE_SUCCESS", null, null, null, () => {
            this.ref.close(this.document)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        console.log(JSON.stringify(error))
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )

  }

  /**
   * validate all field
   */
  validateAll() {
    this.storicoRisposte.forEach(risposta => {
      risposta.Valido = true
    })
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any, question: IMatriceDomande) {
    this.uploadedFiles = []
    let uploadedAntimafiaFile: any
    upload.clear()
    if (question.StatoAntimafia) {
      uploadedAntimafiaFile = event.files[0];
      this.fileAntimafiaName = uploadedAntimafiaFile.name
    }
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    Loading.isLoading = true
    this.documentiService.uploadAllegato(this.uploadedFiles[0], question.Allegato.Numero_allegato, this.document.Id.toString(), this.uploadedFiles[0].name).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          let allegSaved: IAllegati = response.data
          question.Allegato = allegSaved //save local obj with response obj
          if (uploadedAntimafiaFile) {
            this.allegatoAntimafiaId = allegSaved.Id
          }
        } else {
          //this.alertUtil.showErrorAlert("LBL_ERROR_300")
          console.log("Errore nel caricamento dell'allegato" + JSON.stringify(response));
        }
      })
  }
  /**
    * determines whether all fields mandatory are filled 
    */
  private areAllMandatoriesFilled(): boolean {
    let allMandatoriesFilled: boolean = true

    if (!this.isAffidatario) {
      // iterate over all questions
      this.questions.forEach(question => {
        //find question answer based on Domanda_Id
        let questionAnswer = this.storicoRisposte.find(answer => answer.Domanda_Id == question.Id)

        //check if answer is mandatory and no answer is no given
        question.AnswerMissing = question.Obbligatorio && !questionAnswer.Valore
        if (question.AnswerMissing) {
          allMandatoriesFilled = false
        }
      });
    }

    return allMandatoriesFilled
  }


  /**
   * open allegato in other tab
   */
  openAllegato(event: any, question: IMatriceDomande) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      ModuloId: this.document.Id,
      NumeroAllegato: question.Allegato.Numero_allegato,
      Versione: this.selectedVersion && this.selectedVersion.Versione ? this.selectedVersion.Versione : -1
    })
    this.documentiService.visualizzaAllegato(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          //check allegato extension
          let allegatoType = question.Allegato.Estensione.trim()
          let allegatoNome = question.Allegato.Nome
          if (!allegatoType) {
            allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
          }
          if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
            Util.showPdf(response)
          } else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
            || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
            // Modifica del 20.01.2025
            // Aggiunta substring all'estensione del file per togliere il punto che manda in errore la visualizzazione
            this.attachmentUrl = "data:image/" + allegatoType.substring(1) + ";base64," + response
            //Apertura dell'overlay panel
            this.op.toggle(event)

          } else {
            Util.downloadFile(response, allegatoType, allegatoNome)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * delete allegato service
   * @param event 
   * @param question 
   */
  deleteAllegato(event: any, question: IMatriceDomande) {
    this.alertUtil.showConfirmationAlert("LBL_ALLEGATO_DELETE", null, null, null, null, () => {
      Loading.isLoading = true
      question.Allegato.Blob = null
      let requestBuilder = new RequestBuilder(question.Allegato)

      this.documentiService.deleteAllegato(requestBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response && response["error"] == null) {
            question.Allegato.Nome = null
          }
          else
            if (response.error) {
              let errorKey = "LBL_ERROR_" + response.error.Code
              this.alertUtil.showErrorAlert(errorKey)
              console.log("ERROR: " + JSON.stringify(response.error.Stack))
            }
            else {
              this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
            }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })

  }

  showBtnAntimafia(question: IMatriceDomande) {
    return !question.StatoAntimafia
  }

  /**
   * Disabilita l'input in base a diverse condizioni di stato e permessi.
   * @param question La domanda corrente.
   */
  isDisabledInput(question?: IMatriceDomande): boolean {
    if (!question) {
      return false; // O true, a seconda del comportamento desiderato per una domanda mancante
    }

    // -----------------------------------------------------
    // 1. Condizioni Generali di Disabilitazione (Sempre valide)
    // -----------------------------------------------------
    const isFullTextSearch = this.fromFullTextSearch;
    const isAggiudicatarioDisabled = question && question.StatoAntimafia && this.isAggiudicatario;

    // Se è FullTextSearch o se ha StatoAntimafia ed è Aggiudicatario, disabilita subito.
    if (isFullTextSearch || isAggiudicatarioDisabled) {
      return true;
    }

    // -----------------------------------------------------
    // 2. Condizioni Specifiche per showBtnAntimafia (Se !question.StatoAntimafia)
    // -----------------------------------------------------
    if (this.showBtnAntimafia(question)) {
      // 2a. Validità Risposta Custom
      const isRispostaValida = !!(question.RispostaCustom && question.RispostaCustom.Valido);

      // 2b. Condizioni di Stato della Richiesta
      const statoInLavorazione = this.richiestaSelected.StatoRichiesta.Nome === Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE;
      const statoApprovatoNonVersioning = this.richiestaSelected.StatoRichiesta.Nome === Enum.REQUEST_STATE_NAME_ENUM.APPROVATO && !this.fromVersioning;

      // 2c. Condizioni di Stato del Modulo (Documento Variazione)
      const variazioneInLavorazione = this.document.StatoModulo && this.document.StatoModulo.Nome === Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_IN_LAVORAZIONE;
      const variazioneApprovata = this.document.StatoModulo && this.document.StatoModulo.Nome === Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.APPROVATO;

      // 2d. Condizione per Gestione Contratto in Variazione
      const isGestioneContrattoVersioningNonUpload = (
        (this.richiestaSelected.TipoContratto.Nome === Constants.TIPO_CONTRATTO
          || this.richiestaSelected.TipoContratto.Nome === Constants.TIPO_RICHIESTA_CONTRATTO_AFFIDATARIA) &&
        this.fromVersioning &&
        question.Tipo !== Enum.INPUT_TYPE_ENUM.UPLOAD
      );

      // Raggruppamento finale delle condizioni OR
      const disabledConditions =
        this.isAdmin ||
        this.isAffidatario ||
        isRispostaValida ||
        statoInLavorazione ||
        statoApprovatoNonVersioning ||
        variazioneInLavorazione ||
        variazioneApprovata ||
        isGestioneContrattoVersioningNonUpload;

      return disabledConditions;
    }

    // Se non ricade in nessuna delle condizioni precedenti, l'input è abilitato.
    return false;
  }

  /**
   * disable save button
   * @param rispostaCustom 
   */
  //
  isDisabledSaveButton(): boolean {
    let isDisabled = false
    isDisabled = this.isAdmin ||
      (this.isAggiudicatario && this.richiestaSelected.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.IN_LAVORAZIONE) ||
      (this.richiestaSelected.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.APPROVATO && !this.fromVersioning) || this.fromFullTextSearch
      || (this.isAggiudicatario && this.document.StatoModulo && this.document.StatoModulo.Nome == Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_IN_LAVORAZIONE)
    return isDisabled
  }

  /**
   * disabled validate button
   */
  isDisabledValidateButton() {
    return this.isAdmin || this.isAggiudicatario
      || (this.richiestaSelected.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.APPROVATO && !this.fromVersioning)
      || this.fromFullTextSearch
      || this.isAffidatario &&
      (this.richiestaSelected.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.BOZZA
        || this.richiestaSelected.StatoRichiesta.Nome == Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO)
  }



  /**
   * btn click and check status of document
   */
  unlockButtonCLick() {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.document.Id
    })
    this.documentiService.checkStatus(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.isDisabledUnlockButton = true
        //check response and unlock field. lock all fields for contratti and unlock uploads.
        this.lockField = this.richiestaSelected.TipoContratto.Nome == Constants.TIPO_CONTRATTO
        this.lockUpload = false
      } else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + JSON.stringify(response.error.Stack))
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })

  }


  /**
   * on change dropdown versioni
   * @param event 
   */
  onChangeVersione(event: any) {
    let versioneSelected: IVersione = event.value
    this.isDisabledUnlockButton = (versioneSelected.Versione < this.maxVersion) ? (true && this.document.Richiesta.GUID_utente != this.userGuid) : false
    this.indexQuestion = 1
    this.callDocumentoFetchSingle(versioneSelected)
  }


  /**
   * call documento fetch single
   */
  callDocumentoFetchSingle(versione: IVersione) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.document.Id,
      Version: versione.Versione
    })
    this.storicoModuloService.storicoModuloFetchSingle(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.document = response.data
          this.createCustomResponse()
          this.ngOnInit()//reload
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * read documento with version and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.document.StoricoRisposte //get storico risposte array
    let matrDomande = this.document.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            storicoRisp.Valido = true
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }


  /**
   * return max value of number array
   * @param numArray 
   */
  getMaxOfArray(): number {
    let versionNumber: number[] = [];
    this.versionList.forEach(version => {
      versionNumber.push(version.Versione);
    });
    return Math.max.apply(null, versionNumber);
  }

  /**
   * close calendar for field datascadenza allegato and call service for save datascadenza
   */
  scadenzaAllegato(question: IMatriceDomande) {
    if (question.Allegato && question.Allegato.DataScadenza) {
      question.Allegato.Scadenza = this.formatDateForSave(question.Allegato.DataScadenza)
    } else {
      question.Allegato.Scadenza = null
    }
    this.callSaveScadenzaAllegato(question)
  }

  /**
   * save datascadenza allegato
   * @param question matrice domanda
   * @param dataScadenza data scadenza of allegato
   */
  callSaveScadenzaAllegato(question: IMatriceDomande) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id_Modulo: this.document.Id,
      Num_Allegato: question.Allegato.Numero_allegato,
      Scadenza: question.Allegato.Scadenza
    })
    this.documentiService.saveScadenzaAllegato(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          // let allegSaved: IAllegati = response.data
          // question.Allegato = allegSaved //save local obj with response obj

        } else {
          //this.alertUtil.showErrorAlert("LBL_ERROR_300")
          console.log("Errore nel salvataggio della data di scadenza allegato " + JSON.stringify(response));

        }
      }
    )
  }


  /**
   * check expiration date for upload field
   * and set ngClass
   * @param question matrice domande
   */
  private checkExpirationDate(question: IMatriceDomande) {
    if (question.Allegato && question.Allegato.DataScadenza) {
      this.calculateAllegatoState(question.Allegato)
    }
  }


  /**
   * calculate state of allegato
   */
  calculateAllegatoState(allegato: IAllegati) {
    let giorniPreavviso: string = "30"
    let dataScadenza = Moment(allegato.DataScadenza);//data scadenza from allegato
    let dataPreavviso = Moment(allegato.DataScadenza).subtract(giorniPreavviso, 'days'); //calculate data Preavviso
    let now = Moment() // data now
    if (now.isAfter(dataScadenza)) {
      allegato.Stato = Enum.SCADENZARIO_STATE_ENUM.SCADUTO
    } else if (!now.isBefore(dataPreavviso)) {
      allegato.Stato = Enum.SCADENZARIO_STATE_ENUM.IN_SCADENZA
    }
  }

  /**
   * set ngClass at label allegato for expiration date
   */
  labelNgClass(question: IMatriceDomande): string {
    let ngClass: string = ""
    if (question.AnswerMissing || (question.Allegato && question.Allegato.Stato == Enum.SCADENZARIO_STATE_ENUM.SCADUTO)) {
      ngClass = "missing-answer"
    } else if ((question.Allegato && question.Allegato.Stato == Enum.SCADENZARIO_STATE_ENUM.IN_SCADENZA)) {
      ngClass = "yellow-answer"
    }
    return ngClass
  }

  /**
   * chiamata al servizio per la precompilazione di alcuni campi del documento
   */
  onPrecompilaDocumento() {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({ Id: this.document.Id }, ["StoricoModuli.StoricoRisposte", "StoricoModuli.MatriceModulo.MatriceDomande", "StoricoModuli.Allegati"])
    this.richiestaService.getSuggerimenti(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          if (response.data.StoricoModuli) {
            response.data.StoricoModuli.forEach(item => { //ciclo l'array di storico Moduli
              if (this.document.Id == item.Id) { //trovo il documento su cui stiamo lavorando
                this.document = item //Salvo il documento
                this.createSuggerimento()
                this.indexQuestion = 1
                this.ngOnInit()//reload
              }
            });
          }
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          //this.alertUtil.showErrorAlert("LBL_ERROR_300")
          console.log("Errore generico " + JSON.stringify(response));

        }
      }
    )

  }

  /**
   * read documento with version and set Suggerimento for questions with response
   */
  createSuggerimento() {
    let storicoRisposte = this.document.StoricoRisposte //get storico risposte array
    let matrDomande = this.document.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if ((storicoRisp.Valido == null || !storicoRisp.Valido) && storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question and is not Valido set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
   * get esecutore string for single question
   * @param question question Item
   */
  getEsecutoreObjForLabelEsecutoreQuestion(question: IMatriceDomande): string {
    let esecutore = ''
    if (this.richiestaSelected && this.richiestaSelected.Esecutore != null) {
      switch (question.Placeholder) {
        case "txtImpresaEsecutore":
          esecutore = this.richiestaSelected.Esecutore.Ragione_sociale
          break
        case "txtSedeEsecutore":
          esecutore = this.richiestaSelected.Esecutore.Comune
          break
        case "txtViaEsecutore":
          esecutore = this.richiestaSelected.Esecutore.Indirizzo
          break
        case "txtCFEsecutore":
          esecutore = this.richiestaSelected.Esecutore.Codice_fiscale
          break
        case "txtPIVAEsecutore":
          esecutore = this.richiestaSelected.Esecutore.Partita_IVA
          break
      }
    }
    return esecutore
  }

  /**
   * get string for single question descrittiva
   * @param question question Item
   */
  getResponseForLabelDescrittivaQuestion(question: IMatriceDomande): string {
    let valore = ''
    if (this.document.StoricoRisposte && this.document.StoricoRisposte.length > 0) {
      for (let i = 0; i < this.document.StoricoRisposte.length; i++) {
        let risposta = this.document.StoricoRisposte[i]
        if (risposta.Placeholder == question.Placeholder) {
          valore = risposta.Valore
          break;
        }
      }
    }
    return valore
  }

  /**
   * radio btn question event
   */
  onClickRadioBtn(question: IMatriceDomande) {
    //recycle list
    this.questions.forEach(questionItem => {
      //checks the match of type and RadioNameButton but the ID is different
      if (questionItem.Tipo == this.TYPE.RADIOBUTTON
        && questionItem.NomeRadioButton == question.NomeRadioButton
        && questionItem.Id != question.Id) {
        let storicoEmpty: IStoricoRisposte = {
          Domanda_Id: questionItem.Id,
          Valore: null,
          Placeholder: null,
          Valido: null
        }
        questionItem.RispostaCustom = storicoEmpty
      }
    })
  }

  /**
   * metodo per nascondere/mostrare sezione Antimafia
   * @param question 
   * @returns 
   */
  showAntimafiaSection(question: IMatriceDomande) {
    if (question.StatoAntimafia == null || (!this.isAdmin)) {
      return true
    }
    return false
  }
}
